import React from "react";
import { Box, Stack, Typography } from "@mui/material";

import promptsLibraryImage from "src/shared/assets/promptsLibrary.png";

export const PromptLibrary: React.FC = () => {
  return (
    <Stack
      width={1}
      justifyContent="flex-start"
      alignItems="center"
      direction="column"
      gap={1}
    >
      <Stack
        width={1}
        direction="row"
        justifyContent="center"
        alignItems="center"
        gap={1}
      >
        <Typography
          color="primary"
          variant="h5"
          textTransform="uppercase"
          fontWeight={300}
        >
          prompts
        </Typography>
        <Typography
          color="text.secondary"
          variant="h5"
          textTransform="uppercase"
          fontWeight={300}
        >
          library
        </Typography>
      </Stack>

      <Typography
        maxWidth={0.7}
        color="text.primary"
        variant="body1"
        textAlign="center"
        sx={{
          fontSize: {
            sm: "1rem",
            xs: "0.875rem",
          },
        }}
      >
        A centralized hub to create, manage, and reuse your most effective
        prompts, streamlining your workflow.
      </Typography>

      <Box width={1}>
        <img width="100%" src={promptsLibraryImage} alt="promptsLibraryImage" />
      </Box>
    </Stack>
  );
};
